import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ThemeToggle } from '@/components/theme-toggle';
import { Settings } from 'lucide-react';

export function AppearanceSettingsTab() {
  return (
    <div className="space-y-4 pt-4">
      <Card>
        <CardHeader>
          <CardTitle>테마 설정</CardTitle>
          <CardDescription>
            앱 화면 테마를 설정합니다
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <p>테마 선택</p>
              <div className="flex items-center gap-2">
                <ThemeToggle />
              </div>
            </div>
            <p className="text-sm text-muted-foreground">
              드롭다운 메뉴를 통해 라이트 모드, 다크 모드, 또는 시스템 기본값을 선택할 수 있습니다.
            </p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>앱 정보</CardTitle>
          <CardDescription>앱 버전 및 정보</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-4">
            <Settings className="h-10 w-10 text-muted-foreground" />
            <div className="space-y-1">
              <p className="font-medium">INSTA LAB AI</p>
              <p className="text-xs text-muted-foreground">버전 1.0.0</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}